<template>
  <div style="margin:1%">
    <b-row align-v="end" align-h="start">
      <b-col cols="2">
        <md-button @click.stop="showAddTechnicalParameters" class="md-raised">{{ $t('Add') }}</md-button>
      </b-col>
      <b-col cols="6">
        <md-field>
          <label for="curCustomers">{{$t('Select account')}}</label>
          <md-select v-model="selectedAccount">
            <md-option v-for="item in currentRow.accounts" :key="item" :value="item"> {{ item }} </md-option>
          </md-select>
        </md-field>
      </b-col>
    </b-row>
    <b-table
    small
    striped
    hover
    :items="TechnicalParameters"
    :fields="TechnicalParametersFields"
    @row-clicked="rowTechnicalParametersClickHandler"
    @row-dblclicked="rowTechnicalParametersDblClickHandler">
       <template v-slot:cell(actions)="row">
        <i @click.stop="ClickOnEditTechnicalParametersButton(row)" class="primary fa fa-edit fa-lg" />
        <i @click.stop="ClickOnDeleteTechnicalParametersButton(row)" class="danger fa fa-trash-alt fa-lg" />
      </template>
    </b-table>

    <b-modal hide-footer :title="$t('Parameters')" ref="modalAddTechnicalParameters">
      <FormAdd
      @hideAddTechnicalParameters="hideAddTechnicalParameters"
      :currentRow="currentRow"
      :selectedAccount="selectedAccount"
      :listOfType="listOfType"
      :listOfLinkId="listOfLinkId"
      :currentRowTechnicalParameters="currentRowTechnicalParameters"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteTechnicalParameters">
      <h5>{{ $t('Are you sure you want to delete one of "Technical parameters"?') }}</h5>
      <b-row>
        <b-col>
          <b-button variant="danger" block @click="deleteTechnicalParameters()">Ok</b-button>
        </b-col>
        <b-col>
          <b-button variant="secondary" block @click="hideDeleteTechnicalParameters()">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import FormAdd from './formAdd.vue'
export default {
  components: {
    FormAdd
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      currentRowTechnicalParameters: null,
      selectedAccount: null,
      TechnicalParametersFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'param', label: this.$i18n.t('Value'), sortable: true },
        { key: 'type_name', label: this.$i18n.t('Type'), sortable: true },
        { key: 'slink_id', label: this.$i18n.t('Link ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ]
    }
  },
  methods: {
    rowTechnicalParametersDblClickHandler (item) {
      this.currentRowTechnicalParameters = JSON.parse(JSON.stringify(item))
      this.$refs.modalAddTechnicalParameters.show()
    },
    ClickOnEditTechnicalParametersButton (row) {
      this.currentRowTechnicalParameters = JSON.parse(JSON.stringify(row.item))
      this.$refs.modalAddTechnicalParameters.show()
    },
    ClickOnDeleteTechnicalParametersButton (row) {
      this.currentRowTechnicalParameters = row.item
      this.$refs.modalDeleteTechnicalParameters.show()
    },
    hideDeleteTechnicalParameters () {
      this.$refs.modalDeleteTechnicalParameters.hide()
    },
    deleteTechnicalParameters () {
      if (this.currentRowTechnicalParameters) {
        let response = this.$store.dispatch('Users/DELETE_TECH_PARAMS', this.currentRowTechnicalParameters)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            let payload = {
              user_id: this.currentRow.user_id,
              account_id: this.selectedAccount
            }
            this.$store.dispatch('Users/GET_TECH_PARAMS', payload)
            this.$root.$emit('makeToasts')
            this.$refs.modalDeleteTechnicalParameters.hide()
          }
        })
      }
    },
    rowTechnicalParametersClickHandler (row) {
      if (this.currentRowTechnicalParameters) {
        this.currentRowTechnicalParameters._rowVariant = ''
      }
      this.currentRowTechnicalParameters = row
      this.$set(this.currentRowTechnicalParameters, '_rowVariant', 'info')
    },
    showAddTechnicalParameters () {
      this.currentRowTechnicalParameters = {
        reg_date: this.$root.setDataWithSelectedTZ().format('YYYY-MM-DDTHH:mm'),
        passwd: '',
        param: '',
        type_id: this.listOfType[0].value,
        slink_id: this.listOfLinkId[0].value
      }
      this.$refs.modalAddTechnicalParameters.show()
    },
    hideAddTechnicalParameters () {
      this.$refs.modalAddTechnicalParameters.hide()
    }
  },
  watch: {
    selectedAccount: function () {
      let payload = {
        user_id: this.currentRow.user_id,
        account_id: this.selectedAccount
      }
      this.$store.dispatch('Users/GET_TECH_PARAMS', payload)
      let setTechParamsSlinks = {
        user_id: this.currentRow.user_id,
        account_id: this.selectedAccount
      }
      this.$store.dispatch('Users/GET_SETTING_TECH_PARAMS_SLINKS', setTechParamsSlinks)
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_SETTING_TECH_PARAMS')
    this.selectedAccount = this.currentRow.accounts[0]
  },
  computed: {
    TechnicalParameters () {
      return this.$store.getters['Users/TECH_PARAMS']
    },
    listOfType () {
      let tmp = []
      for (let el of this.$store.getters['Users/SETTING_TECH_PARAMS']) {
        let newEl = {
          value: el.id,
          text: el.name + ' (' + el.id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfLinkId () {
      let tmp = [
        {value: 0, text: '---'}
      ]
      for (let el of this.$store.getters['Users/SETTING_TECH_PARAMS_SLINKS']) {
        let newEl = {
          value: el.slink_id,
          text: el.service_name + ' (' + el.slink_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/technicalParameters/main.vue